<template>
  <v-col class="ma-0 pa-0 pl-1 pr-1" md="3">
    <NewsFeedDialog :dummyFeed="dummyFeed" ref="feedDialog"></NewsFeedDialog>
    <v-hover>
      <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`" height="100%" @click.stop="$refs.feedDialog.openDialog()">
        <v-row class="ma-0 pa-0">
          <v-col md="3" class="ma-0 pa-0 pt-3 pb-2">
            <v-img :src="`/Rød NAV_logo_CMYK.png`" height="30px" contain/>
          </v-col>
          <v-col md="auto" class="ma-0 pa-0 pt-3">
            <p class="font-weight-bold subtitle-1 text-center mb-0 pb-1" style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
              NAV Tittel
            </p>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-0 pa-2">
            <p class="body-1" style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;">{{dummyFeed.text}}</p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
  </v-col>
</template>

<script>
import NewsFeedDialog from "../dialog/newsFeedDialog.vue";
export default {
  components:{
    NewsFeedDialog
  },
  data(){
    return{
      dummyFeed: [],
      deleteDummyTestData:[
        {id:1, text: "This is a random test 1"},
        {id:2, text: "This is a random test 2"},
        {id:3, text: "This is a random test 3"}
      ]
    }
  },
  beforeMount(){
    this.dummySelect()
  },
  methods:{
    dummySelect(){
      var dummyFeedGotten = Math.floor(Math.random() * this.deleteDummyTestData.length);
      this.dummyFeed = this.deleteDummyTestData[dummyFeedGotten];
    }
  }
}
</script>